export const SET_SUBSCRIPTION_VIEW = 'SET_SUBSCRIPTION_VIEW';

export const setSubscriptionView = (subscription) => ({
  type: SET_SUBSCRIPTION_VIEW,
  payload: subscription,
});
